import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffDeleteIntegrationModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffDeleteIntegrationModalContainer" */
      './StaffDeleteIntegrationModalContainer'
    ),
  loading: LoadingModal,
});
